import Vue from "vue";
import Component from "vue-class-component";
import { HandleScrollStore, SearchinStore } from "@/UI/Decorators/decorator";
import { mixins } from "vue-class-component";

@Component
export class SearchMix extends mixins() {
    @SearchinStore
    hSearch(source: string, value: string, useStudio: boolean, name?:string, filter?:any): void {}

    @HandleScrollStore
    hScroll(event: any, value: string): void {}

    handleSearch(source: string, value: string, useStudio: boolean, name?:string, filter?:any): void {
        this.hSearch(source, value, useStudio, name, filter);
    }

    certSearch(source: string, value: string, useStudio: boolean, name: string, filter:any): void {
        this.handleSearch("loyaltyCerts", value, false, 'client_id', {})
    }
    certTypeSearch(value: any): void {
        this.handleSearch("loyaltyCertType", value, false);
    }

    /*certSearch(value: any): void {
        this.handleSearch("loyaltyCerts", value, false);
    }*/

    //loyaltyCerts

    handleScrollCertType(event: any, value: string): void {
        this.hScroll(event, "loyaltyCertType");
    }
}
